/* @jsxImportSource react */

import {
  NewEnergyEfficiencyFlag,
  type NewEnergyEfficiencyFlagProps,
} from './NewEnergyEfficiencyFlag/NewEnergyEfficiencyFlag';
import {
  LegacyEnergyEfficiencyFlag,
  type LegacyEnergyEfficiencyFlagProps,
} from './LegacyEnergyEfficiencyFlag/LegacyEnergyEfficiencyFlag';

export type EnergyEfficiencyFlagSpecificProps =
  | NewEnergyEfficiencyFlagProps
  | LegacyEnergyEfficiencyFlagProps;

export const EnergyEfficiencyFlag = ({ ...props }: EnergyEfficiencyFlagSpecificProps) =>
  'text' in props ? (
    <LegacyEnergyEfficiencyFlag {...props} />
  ) : (
    <NewEnergyEfficiencyFlag {...props} />
  );

EnergyEfficiencyFlag.displayName = 'EnergyEfficiencyFlag';
